import { MutableRefObject, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

import {
  EMBEDDED_CHAT_KEY,
  EMBEDDED_CHAT_VALUE,
} from '~/features/chatbot/constants'
import { sendMinimizeChange } from '~/features/chatbot/utils'
import { store } from '~/store'

const useIsEmbeddedChat = () => {
  const [isMinimized, setChatbot] = store((state) => [
    state.chatbot.isMinimized,
    state.setChatbot,
  ])
  const [searchParams] = useSearchParams()

  const isEmbedded = searchParams.get(EMBEDDED_CHAT_KEY) === EMBEDDED_CHAT_VALUE

  const handleToggleMinimize = useCallback(
    ({ headerRef }: { headerRef: MutableRefObject<HTMLDivElement | null> }) => {
      if (!headerRef.current) return

      sendMinimizeChange({
        height: headerRef.current.clientHeight,
        isMinimized: !isMinimized,
      })
      setChatbot({ isMinimized: !isMinimized })
    },
    [isMinimized, setChatbot],
  )

  return {
    handleToggleMinimize,
    isMinimized,
    isEmbedded,
  }
}

export default useIsEmbeddedChat
